import { useTranslation } from 'react-i18next';
import {
  CalendarLayout,
  ConsentLoading,
  ConsentSessionExpired,
  ConsentAlreadyDone,
  ConsentContextForm,
} from './components';
import { useConsentSession, useConfirmConsentContext } from './hooks';
import { CONSENT_STATUS } from './constants';
import * as S from './styles';

const bodyByStatus = {
  [CONSENT_STATUS.loading]: ConsentLoading,
  [CONSENT_STATUS.expired]: ConsentSessionExpired,
  [CONSENT_STATUS.alreadyDone]: ConsentAlreadyDone,
  [CONSENT_STATUS.ready]: ConsentContextForm,
  [CONSENT_STATUS.sending]: ConsentContextForm,
  [CONSENT_STATUS.noSelection]: ConsentContextForm,
  [CONSENT_STATUS.failed]: ConsentContextForm,
};

export default function CalendarSelectContext() {
  const [t] = useTranslation('calendar');

  const {
    session,
    email,
    contexts,
    selectedOptionId,
    setSelectedOptionId,
    status,
    setStatus,
  } = useConsentSession();

  const { confirm } = useConfirmConsentContext({
    session,
    selectedOptionId,
    setStatus,
  });

  const Body = bodyByStatus[status] || ConsentLoading;

  return (
    <CalendarLayout>
      <Body
        email={email}
        contexts={contexts}
        selectedOptionId={selectedOptionId}
        status={status}
        onSelect={setSelectedOptionId}
        onSubmit={confirm}
      />

      <S.LegalNotice>{t('select-context.trademarks')}</S.LegalNotice>
    </CalendarLayout>
  );
}
